import axios from 'axios';
import { IPostcardImage, IPosterImage, IProduct, IProductLogo } from 'src/infrastructure/interfaces';

export default class ImageService {

  static getProductLogos() {

    return new Promise((resolve, reject) => {
      axios
        .get('/products_logo?archived=false')
        .then((res) => {
          resolve(res.data);
        })
        .catch(error => reject(error));
    });
  }

  static archiveProductLogo(logo: IProductLogo) {
    const logoArchived = {...logo, archived: true}
    return new Promise((resolve, reject) => {
      axios
        .put(`/products_logo/${logo.id}`, logoArchived)
        .then((res) => {
          resolve(logoArchived);
        })
        .catch(error => reject(error));
    });
  }

  static archivePostcardImage(postcardImage: IPostcardImage) {
    const postcardArchived = {...postcardImage, is_archived: true}
    return new Promise((resolve, reject) => {
      axios
        .put(`/postcard_images/${postcardImage.id}`, postcardArchived)
        .then((res) => {
          resolve(postcardArchived);
        })
        .catch(error => reject(error));
    });
  }

  static archivePosterImage(posterImage: IPosterImage) {
    const posterArchived = {...posterImage, is_archived: true}
    return new Promise((resolve, reject) => {
      axios
        .put(`/poster_images/${posterImage.id}`, posterArchived)
        .then((res) => {
          resolve(posterArchived);
        })
        .catch(error => reject(error));
    });
  }

  static getProductIcons() {

    return new Promise((resolve, reject) => {
      axios
        .get('/products_icon')
        .then((res) => {
          resolve(res.data);
        })
        .catch(error => reject(error));
    });
  }

  static saveProductImages(product: IProduct, formData: FormData) {

    formData.set('productID', product.id.toString());
    formData.set('productType', product.type);

    return new Promise((resolve, reject) => {
        axios
          .post('/productImageUpload',
              formData,
              { headers: {'Content-Type': 'multipart/form-data' }})
          .then((res) => {
              resolve(res.data);
          })
          .catch(error => reject(error));
      });
  }

  static uploadProductLogo(formData: FormData) {

    return new Promise((resolve, reject) => {
      axios
        .post('/productLogoUpload',
            formData,
            { headers: {'Content-Type': 'multipart/form-data' }})
        .then((res) => {
            resolve(res.data);
        })
        .catch(error => reject(error));
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/ImageService.ts